// action - mission reducer
import {
    FLIGHT_INDICATORS_PENDING,
    FLIGHT_INDICATORS_FAILURE,
    GET_FLIGHT_INDICATORS_SUCCESS,
    UPDATE_COMMANDS_SUCCESS,
    CLEAR_COMMANDS_SUCCESS,
} from 'store/actions-type/flight-indicators';

// initial state
const initialState = {
    commands: { throttle: null, roll: null, yaw: null, tilt: null },
    flightIndicators: null,
};
// ==============================|| SLICE - FLIGHT INDICATORS ||============================== //

export default function flightIndicatorsReducer(state = initialState, action) {
    switch (action.type) {
        case FLIGHT_INDICATORS_PENDING:
            return {
                ...state,
                pending: true,
                error: null,
            };

        case FLIGHT_INDICATORS_FAILURE:
            return {
                ...state,
                pending: false,
                error: action.payload.error,
            };

        // action - get flight indicators
        case GET_FLIGHT_INDICATORS_SUCCESS:
            return {
                ...state,
                pending: false,
                flightIndicators: action.payload,
            };

        // action - update flight commands
        case UPDATE_COMMANDS_SUCCESS: {
            const prev = state.commands || {};
            const raw = action.payload || {};
            // Normalize values: null/undefined/NaN -> 0
            const next = {
                throttle: Number.isFinite(raw.throttle) ? raw.throttle : 0,
                yaw: Number.isFinite(raw.yaw) ? raw.yaw : 0,
                tilt: Number.isFinite(raw.tilt) ? raw.tilt : 0,
                roll: Number.isFinite(raw.roll) ? raw.roll : 0,
            };
            const same =
                prev.throttle === next.throttle &&
                prev.yaw === next.yaw &&
                prev.tilt === next.tilt &&
                prev.roll === next.roll;
            if (same) return state;
            return { ...state, commands: next, pending: false };
        }

        // action - clear flight commands
        case CLEAR_COMMANDS_SUCCESS:
            return {
                ...state,
                commands: { throttle: 0, roll: 0, yaw: 0, tilt: 0 },
                pending: false,
            };

        default:
            return state;
    }
}
